import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'ClientUser';
const ENDPOINT = `/client-users/`;

@Injectable({
    providedIn: 'root'
})
export class ClientUserService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
